"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Definition = void 0;
const default_session_1 = require("../../../../session/default-session");
const metadata_provider_1 = require("../metadata-provider");
const table_builder_1 = require("../../table-builder");
function Definition(params) {
    const tableBuilder = new table_builder_1.TableBuilderImp();
    return {
        getData(session = (0, default_session_1.getDefault)()) {
            const metadataProvider = new metadata_provider_1.MetadataProvider(session, tableBuilder);
            return metadataProvider.getPartialbar(params);
        },
    };
}
exports.Definition = Definition;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVmaW5pdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy9jb250ZW50L2hpc3RvcmljYWwtcHJpY2luZy9tZXRhZGF0YS9wYXJ0aWFsYmFyL2RlZmluaXRpb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQ0EseUVBQWlFO0FBQ2pFLDREQUF3RDtBQUN4RCx1REFBc0Q7QUFFdEQsU0FBZ0IsVUFBVSxDQUN0QixNQUFvRDtJQUVwRCxNQUFNLFlBQVksR0FBRyxJQUFJLCtCQUFlLEVBQUUsQ0FBQztJQUUzQyxPQUFPO1FBQ0gsT0FBTyxDQUFDLFVBQW1CLElBQUEsNEJBQVUsR0FBRTtZQUNuQyxNQUFNLGdCQUFnQixHQUFHLElBQUksb0NBQWdCLENBRzNDLE9BQU8sRUFBRSxZQUFZLENBQUMsQ0FBQztZQUV6QixPQUFPLGdCQUFnQixDQUFDLGFBQWEsQ0FBQyxNQUFNLENBQUMsQ0FBQztRQUNsRCxDQUFDO0tBQ0osQ0FBQztBQUNOLENBQUM7QUFmRCxnQ0FlQyJ9